import { Component, ViewEncapsulation, OnInit, AfterViewInit, OnDestroy, Input, ViewChild, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy, ElementRef } from "@angular/core";
import { Subscription, Subject } from "rxjs";
import { Campaign } from "../../modals/campaigns/campaign";
import { BillingGridService } from "../services/billing-grid.service";
import { SelectItem, SelectItemGroup, Dropdown, OverlayPanel } from "primeng/primeng";
import { BillingActionDispatcher } from "../action-dispatcher/action-dispatcher";
import { CampaignQueryParams } from "../../modals/queryparams/campaign-queryparams";
import { ActivatedRoute } from "@angular/router";
import { CampaignService } from "../../services/shared/campaign.service";
import { Invoice } from "../../modals/billings/invoice";
import { InvoiceGstDetail } from "../../modals/billings/invoice-gst-detail";
import { ImageFolderConfig } from "../../modals/image/image-folder-config";
import { FirebaseService } from "../../services/shared/firebase.service";
import * as _ from 'lodash';
import { Customer } from "../../modals/KYC/customer";
import { NgModel, FormGroup, FormControl } from "@angular/forms";
import { FormBuilder } from '@angular/forms';
import { TopHoardingTimelineComponent } from "../../dashboard/top-hoarding-timeline/top-hoarding-timeline.component";
import { takeUntil, map, catchError } from 'rxjs/operators';
import { ChangesService } from '../../services/shared/changes.service';
import { ActivityLogModuleEnum } from '../../shared/constants/activity-log-module-enum';
import { CustomerUiService } from '../../customers/services/customer-ui.service';
import { NotificatoinsService } from '../../services/notifications/notifications.service';
import { InvoiceFormatEnum } from '../../shared/constants/invoice-format-enum';
import * as utils from '../../helpers/utils';
import { PrintConfig } from '../../modals/billings/print-config';
import { CommonService } from '../../services/shared/common.service';
import { SIBConstants } from '../../shared/constants/SIBConstant';
import { InvoiceChartService } from '../../services/shared/invoice-chart.service';
import { ErrorUtil } from '../../helpers/error.utils';
import { NotificationsMessages } from '../../services/shared/notifications-messages';
import { BillingConfigurationService } from '../../services/shared/billing-configuration.service';
import { AppUrls } from '../../services/urls';
import { VendorService } from '../../services/shared/vendor.service';
import { SupplierWrapper } from '../../modals/billings/supplier-wrapper';

@Component({
    selector: 'sib-add-invoice-details',
    templateUrl: './add-invoice-details.component.html',
    styleUrls: ['./add-invoice-details.component.scss'],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
})

export class AddInvoiceDetailsComponent implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild('addInvoiceId') invId: ElementRef;
    subscription: Subscription[] = [];
    companies: SelectItem[] = [];
    invoiceFormats: SelectItem[] = [];
    placeOfSupply: SelectItem[] = [];
    branches: SelectItemGroup[] = [];
    supplierBranches: SelectItemGroup[] = [];
    branchDropdown = false;
    supplierBranchDropdown = false;
    showSupplierBranches = true;
    purchaseOrders: SelectItem[] = [];
    loading = false;
    displayUploadPODialog = false;
    campaignId: string;
    campaign: Campaign = new Campaign();
    imageFolderConfig: ImageFolderConfig = new ImageFolderConfig();
    customerGroups: any;
    invoiceDetailForm: FormGroup;
    selectedBranchObject: any = null;
    selectedSupplierBranchObject: any = null;
    poToSet: any[] = []; // to set the newly uploaded pos
    poUnsub: Subject<boolean> = new Subject<boolean>();
    grouped = false;
    isDuplicate: boolean = false;
    isWithoutDetail: boolean = false;
    isWithoutLetterHead: boolean = false;
    userRole: string = '';
    printOverlay: boolean = false;
    isPrintOptionChanged: boolean = false;
    changedPrintArray: boolean[] = [false, false, false];

    original = false;
    withLetterHead = false;

    // remove after adding print config in back end and integrating all apis
    printConfig: PrintConfig = new PrintConfig();
    displayInvoiceIdDialog: boolean = false;
    isLoading: boolean = false;
    invoiceId: string = '';
    disableButton: boolean = false;

    _invoice: any;
    @Input() set invoice(invoice) {
        if (invoice) {
            this._invoice = invoice;
            this.grouped = this._invoice.grouped;
            this.original = this._invoice.printConfiguration ? this._invoice.printConfiguration.original : this.original;
            this.withLetterHead = this._invoice.printConfiguration ? this._invoice.printConfiguration.withLetterHead : this.withLetterHead;
            if (this.invoiceDetailForm) {
                this.setStateAndAddress();
            }
            this._invoice = JSON.parse(JSON.stringify(this._invoice));
        }
    }

    get invoice() {
        return this._invoice;
    }
    _migratedInvoice = false;
    @Input() set migratedInvoice(migratedInvoice) {
        this._migratedInvoice = migratedInvoice;
        this._migratedInvoice = JSON.parse(JSON.stringify(this._migratedInvoice));
    }

    get migratedInvoice() {
        return this._migratedInvoice;
    }

    @Input() initialInvoiceId: string;

    @Output() eEmitSelectedCompany: EventEmitter<any> = new EventEmitter();
    @Output() eEmitSelectedInvoiceFormat: EventEmitter<any> = new EventEmitter();
    @Output() eEmitSelectedBranch: EventEmitter<any> = new EventEmitter();
    @Output() eEmitSelectedSupplierBranch: EventEmitter<any> = new EventEmitter();
    @Output() eEmitSelectedPO: EventEmitter<any> = new EventEmitter();
    @Output() eEmitInvoiceNote: EventEmitter<any> = new EventEmitter();
    @Output() eEmitInternalNote: EventEmitter<any> = new EventEmitter();
    @Output() eEmitSelectedPlaceOfSupply: EventEmitter<any> = new EventEmitter();
    @Output() eEmitIsGrouped: EventEmitter<any> = new EventEmitter();
    @Output() eEmitInvoiceRefId: EventEmitter<any> = new EventEmitter();
    @Output() eEmitPrintConfiguration: EventEmitter<any> = new EventEmitter();
    @Output() eEmitChangedPrintType: EventEmitter<any> = new EventEmitter();
    @Output() eEmitChangedPrintLetterHead: EventEmitter<any> = new EventEmitter();
    @Output() eEmitPreviewPrintItems: EventEmitter<any> = new EventEmitter();
    @Output() eEmitInvoiceId: EventEmitter<any> = new EventEmitter();
    @Output() eEmitInvoiceIdCreationStrategy: EventEmitter<any> = new EventEmitter();
    @Output() eEmitSupplier: EventEmitter<any> = new EventEmitter();

    @ViewChild('printMenu') printMenu: OverlayPanel;
    // @ViewChild('invoiceDetailForm')
    // invoiceDetailForm;

    // @ViewChild('company')
    // companyElement: NgModel;

    // get displayName() {
    //     return this.invoiceDetailForm.get('displayName').value;
    // }

    // set displayName(value) {
    //     this.invoiceDetailForm.patchValue({
    //         displayName: value
    //     });
    // }

    get selectedInvoiceFormat() {
        return this.invoiceDetailForm.get('selectedInvoiceFormat').value;
    }

    set selectedInvoiceFormat(value) {
        this.invoiceDetailForm.patchValue({
            selectedInvoiceFormat: value,
        });
    }

    get selectedCompany() {
        return this.invoiceDetailForm.get('selectedCompany').value;
    }

    set selectedCompany(value) {
        this.invoiceDetailForm.patchValue({
            selectedCompany: value,
        });
    }

    get selectedBranch() {
        return this.invoiceDetailForm.get('selectedBranch').value;
    }

    set selectedBranch(value) {
        this.invoiceDetailForm.patchValue({
            selectedBranch: value,
        });
    }

    get selectedSupplierBranch() {
        return this.invoiceDetailForm.get('selectedSupplierBranch').value;
    }

    set selectedSupplierBranch(value) {
        this.invoiceDetailForm.patchValue({
            selectedSupplierBranch: value,
        });
    }

    get gst() {
        return this.invoiceDetailForm.get('gst').value;
    }

    set gst(value) {
        this.invoiceDetailForm.patchValue({
            gst: value,
        });
    }

    get pan() {
        return this.invoiceDetailForm.get('pan').value;
    }

    set pan(value) {
        this.invoiceDetailForm.patchValue({
            pan: value,
        });
    }

    get state() {
        return this.invoiceDetailForm.get('state').value;
    }

    set state(value) {
        this.invoiceDetailForm.patchValue({
            state: value,
        });
    }

    get address() {
        return this.invoiceDetailForm.get('address').value;
    }

    set address(value) {
        this.invoiceDetailForm.patchValue({
            address: value,
        });
    }

    get selectedPlaceOfSupply() {
        return this.invoiceDetailForm.get('selectedPlaceOfSupply').value;
    }

    set selectedPlaceOfSupply(value) {
        this.invoiceDetailForm.patchValue({
            selectedPlaceOfSupply: value,
        });
    }

    get selectedPO() {
        return this.invoiceDetailForm.get('selectedPO').value;
    }

    set selectedPO(value) {
        this.invoiceDetailForm.patchValue({
            selectedPO: value,
        });
    }

    get invoiceNote() {
        return this.invoiceDetailForm.get('invoiceNote').value;
    }

    set invoiceNote(value) {
        this.invoiceDetailForm.patchValue({
            invoiceNote: value,
        });
    }

    get internalNotes() {
        return this.invoiceDetailForm.get('internalNotes').value;
    }

    set internalNotes(value) {
        this.invoiceDetailForm.patchValue({
            internalNotes: value,
        });
    }

    get refInvoiceId() {
        return this.invoiceDetailForm.get('refInvoiceId').value;
    }

    set refInvoiceId(value) {
        this.invoiceDetailForm.patchValue({
            refInvoiceId: value,
        });
    }

    @ViewChild("groupedDropdown") groupedDropdown: Dropdown;

    @ViewChild("supplierGroupedDropdown") supplierGroupedDropdown: Dropdown;

    invIdCreationStrategy: string;
    invEditPending: boolean = false;

    constructor(
        private billingGridService: BillingGridService,
        private billingActionDispatcher: BillingActionDispatcher,
        private route: ActivatedRoute,
        private campaignService: CampaignService,
        private changeDetectorRef: ChangeDetectorRef,
        private firebaseService: FirebaseService,
        private fb: FormBuilder,
        private changesService: ChangesService,
        private customerUiService: CustomerUiService,
        private commonService: CommonService,
        private notificationService: NotificatoinsService,
        private invoiceService: InvoiceChartService,
        private billingConfigurationService: BillingConfigurationService,
        private vendorService: VendorService,
    ) { }

    ngOnInit() {
        this.loading = true;
        this.invoiceId = this.invoice.invoiceId;
        this.setInvoiceDetailForm();
        this.getBillingConfiguration();
        this.getSupplierInformation();
        this.userRole = this.customerUiService.getUserRole();
        this.placeOfSupply.push({ label: 'Gujarat', value: 'Gujarat' });
        this.setInvoiceFormatDropdown();
        this.subscription.push(this.route.params.subscribe((value: { campaign: boolean }) => {
            if (value.campaign || value.campaign === undefined) {
                this.subscription.push(this.route.params.subscribe((params: { id: string }) => {
                    this.campaignId = params.id;
                    this.getCampaign();
                }));
            }
        }));
    }

    /**
     * @description to get the suppleir information
     * @author Pulkit Bansal
     * @date 2019-12-23
     * @memberof AddInvoiceDetailsComponent
     */
    getSupplierInformation() {
        this.vendorService.get(null, localStorage.id).subscribe(
            (vendorDetails) => {
                if (vendorDetails) {
                    this.invoice.supplier = new SupplierWrapper().setSupplierWrapper(vendorDetails, this.invoice.supplier.supplierGstDetail);
                    this.eEmitSupplier.emit(this.invoice.supplier);
                    this.setSupplierBranches();
                }
            },
            (error) => {
                this.notificationService.error(error.error ? error.error.message ? error.error.message : 'Some technical issue' : error.message, 'Error!!');
            }
        );
    }

    setSupplierBranches() {
        this.supplierBranches = [];
        this.selectedSupplierBranchObject = null;
        this.selectedSupplierBranch = "";
        if (this.supplierGroupedDropdown) {
            this.supplierGroupedDropdown.value = "";
        }
        if (this.invoice.supplier && this.invoice.supplier.gstDetails) {
            this.invoice.supplier.gstDetails.forEach((gst) => {
                const items: SelectItem[] = [];
                gst.branchAddress.forEach((add) => {
                    const value = { address: add, gst: gst };
                    items.push({ label: add.branchName + '-' + add.city.name, value: value });
                });
                this.supplierBranches.push({ label: gst.gstNo, value: gst, items: items });
            });
        }
        if (this.supplierBranches.length > 0) {
            this.supplierBranchDropdown = true;
        } else {
            this.supplierBranchDropdown = false;
        }
        if (this.supplierBranches && this.supplierBranches.length) {
            this.setSelectedSupplierBranch();
        }
    }

    setSelectedSupplierBranch() {
        this.supplierBranches.forEach((branch) => {
            branch.items.forEach((item, ind) => {
                if (this.checkEquality(item.value, this.invoice.supplier.supplierGstDetail)) {
                    this.selectedSupplierBranchObject = this.createBranchItemObject(item.value);
                    this.selectedSupplierBranch = item.value;
                    this.supplierGroupedDropdown.value = item.value;
                }
            });
        });
        // if only one supplier branch is there, select by default
        if (this.supplierBranches && this.supplierBranches.length === 1) {
            this.showSupplierBranches = false;
            if (!this.selectedSupplierBranch) {
                this.selectedSupplierBranchObject = this.createBranchItemObject(this.supplierBranches[0].items[0].value);
                this.selectedSupplierBranch = this.supplierBranches[0].items[0].value;
                if (this.supplierGroupedDropdown) {
                    this.supplierGroupedDropdown.value = this.supplierBranches[0].items[0].value;
                }
            }
        }
        this.setSupplierGstDetail();
    }

    setSupplierGstDetail() {
        this.invoice.supplier.supplierGstDetail = new InvoiceGstDetail().setInvoiceGstDetail(this.selectedSupplierBranchObject);
        this.invoice = JSON.parse(JSON.stringify(this.invoice));
        this.eEmitSelectedSupplierBranch.emit(this.selectedSupplierBranchObject);
        this.setSupplierStateAndAddress();
    }

    onSupplierBranchChange(event) {
        this.selectedSupplierBranch = event.value;
        this.selectedSupplierBranchObject = this.createBranchItemObject(this.selectedSupplierBranch);
        this.eEmitSelectedSupplierBranch.emit(this.selectedSupplierBranchObject);
        this.setSupplierStateAndAddress();
    }

    setSupplierStateAndAddress() {
        // do nothing
    }

    setInvoiceFormatDropdown() {
        this.invoiceFormats = utils.createDropdown(InvoiceFormatEnum, false);
        this.setSelectedInvoiceFormat(null);
    }

    setSelectedInvoiceFormat(event) {
        if (!event) {
            if (this.invoice && this.invoice.invoiceFormat) {
                this.selectedInvoiceFormat = this.invoice.invoiceFormat;
            }
        } else {
            this.selectedInvoiceFormat = event;
        }
        this.onInvoiceFormatChange();
    }

    setInvoiceDetailForm() {
        this.invoiceDetailForm = new FormGroup({
            displayName: new FormControl({ value: '', disabled: true }),
            selectedCompany: new FormControl(''),
            selectedInvoiceFormat: new FormControl(''),
            selectedBranch: new FormControl(''),
            selectedSupplierBranch: new FormControl(''),
            gst: new FormControl({ value: '', disabled: true }),
            pan: new FormControl({ value: '', disabled: true }),
            state: new FormControl({ value: '', disabled: true }),
            address: new FormControl({ value: '', disabled: true }),
            selectedPlaceOfSupply: new FormControl(''),
            selectedPO: new FormControl([]),
            invoiceNote: new FormControl(''),
            internalNotes: new FormControl(''),
            refInvoiceId: new FormControl('')
        });
    }

    getCampaign() {
        this.subscription.push(this.campaignService.getCampaign(this.campaignId).subscribe((campaign: any) => {
            this.campaign = campaign;
            this.campaign.campaignStartDate = new Date(this.campaign.campaignStartDate);
            this.campaign.campaignEndDate = new Date(this.campaign.campaignEndDate);
            if (this.campaign && this.campaign.purchaseOrders && this.invoice.purchaseOrders) {
                this.poToSet.forEach(po => {
                    this.campaign.purchaseOrders.forEach(campaignPo => {
                        if (po.name === campaignPo.name) {
                            this.selectedPO.push(campaignPo);
                        }
                    });
                });
            }
            this.invoiceDetailForm.patchValue({
                displayName: this.campaign.displayName,
            });
            if (this._invoice.note) {
                this.invoiceDetailForm.patchValue({
                    invoiceNote: this._invoice.note,
                });
            }
            if (this._invoice.internalNotes) {
                this.invoiceDetailForm.patchValue({
                    internalNotes: this._invoice.internalNotes
                });
            }
            if (this.migratedInvoice && this._invoice.refInvoiceId) {
                this.invoiceDetailForm.patchValue({
                    refInvoiceId: this._invoice.refInvoiceId

                });
            }
            if (this.campaign.customer.group !== null && this.campaign.customer.group.id !== null) {
                this.getCustomerGroups();
            } else {
                this.setCompanies();
            }
        }));
    }

    getCustomerGroups() {
        this.subscription.push(this.billingGridService.getCustomerGroups(this.campaign.customer.group.id).subscribe((group) => {
            if (group) {
                this.customerGroups = group;
                this.setCompanies();
            }
        }));
    }

    onInvoiceFormatChange() {
        this.eEmitSelectedInvoiceFormat.emit(this.selectedInvoiceFormat);
        this.detectChanges();
    }

    setCompanies() {
        this.companies = [];
        if (this.customerGroups) {
            this.customerGroups.forEach((customer) => {
                // this.companies.push({ label: customer.company, value: customer });
                this.companies.push({ label: customer.billingName, value: customer });
            });
        } else {
            // this.companies.push({ label: this.campaign.customer.company, value: this.campaign.customer });
            this.companies.push({ label: this.campaign.customer.billingName, value: this.campaign.customer });
        }
        this.companies = JSON.parse(JSON.stringify(this.companies));
        this.setSelectedCompany();
    }

    setSelectedCompany() {
        this.companies.forEach((company, index) => {
            if (this.invoice.id === null || this.invoice.id === undefined) {
                // ======================================================================================
                if (this.invoice.campaign.customer && this.invoice.campaign.customer.billingName) {
                    if (company.label === this.invoice.campaign.customer.billingName) {
                        this.selectedCompany = company.value;
                    }
                } else {
                    // ==================================================================================
                    if (company.label === this.campaign.customer.billingName) {
                        this.selectedCompany = company.value;
                    }
                }
            } else {
                // =====================================================================

                if (this.invoice.campaign.customer && this.invoice.campaign.customer.billingName) {
                    if (company.label === this.invoice.campaign.customer.billingName) {
                        this.selectedCompany = company.value;
                    }
                } else {
                    if (company.label === this.invoice.campaign.customer.billingName) {
                        this.selectedCompany = company.value;
                    }
                }

                //  ====================================================================
                // if (company.label === this.invoice.campaign.customer.company) {
                //     this.selectedCompany = company.value;
                // }
            }
        });
        this.selectedCompany = JSON.parse(JSON.stringify(this.selectedCompany));
        this.detectChanges();
        this.setBranches();
        this.setPOList();
        this.setPlaceOfSupply();
        this.loading = false;
    }

    setBranches() {
        this.branches = [];
        // this.selectedBranch = '';
        // this.groupedDropdown.value = '';
        // this.state = '';
        // this.gst = '';
        // this.address = '';
        this.selectedBranchObject = null;
        this.selectedBranch = "";
        this.state = '';
        this.gst = '';
        this.address = '';
        this.groupedDropdown.value = '';
        if (this.selectedCompany !== undefined && this.selectedCompany !== null && this.selectedCompany.gstDetails !== undefined && this.selectedCompany.gstDetails !== null) {
            this.selectedCompany.gstDetails.forEach((gst) => {
                const items: SelectItem[] = [];
                gst.branchAddress.forEach((add) => {
                    const value = { address: add, gst: gst };
                    items.push({ label: add.branchName + '-' + add.city.name, value: value });
                });
                this.branches.push({ label: gst.gstNo, value: gst, items: items });
            });
            if (this.branches.length > 0) {
                this.branchDropdown = true;
            } else {
                this.branchDropdown = false;
            }
            this.eEmitSelectedCompany.emit(this.selectedCompany);
            this.setSelectedBranch();
        }
    }

    onBranchChange(event) {
        // this.selectedBranch = this.createBranchItemObject(event.value);
        this.selectedBranch = event.value;
        this.selectedBranchObject = this.createBranchItemObject(this.selectedBranch);
        this.setGST();
    }

    /**
     *to check which value among the various values of items is selected
     *
     * @param {*} branch
     * @returns
     * @memberof AddInvoiceDetailsComponent
     */
    createBranchItemObject(branch) {
        // branch.gst.branchAddress = branch.gst.branchAddress.filter((add, ind) => {
        //     if (JSON.stringify(add) === JSON.stringify(branch.address)) {
        //         return add;
        //     }
        // });
        const branchClone = _.cloneDeep(branch); // to prevent the actual branch in dropdown from getting changed
        let index;
        branchClone.gst.branchAddress.filter((add, ind) => {
            // if (JSON.stringify(add) === JSON.stringify(branch.address)) {
            // if (JSON.stringify(add) === JSON.stringify(branchClone.gst.branchAddress)) {
            //     index = ind;
            // }
            if (JSON.stringify(branchClone.address) === JSON.stringify(branchClone.gst.branchAddress[ind])) {
                index = ind;
            }
        });
        if (index !== undefined) {
            branchClone.gst.branchAddress = branchClone.gst.branchAddress.filter((add, ind) => {
                if (ind === index) {
                    return add;
                }
            });
            return branchClone.gst;
        }
        // return branch.gst;
    }

    setSelectedBranch() {
        if (this.invoice.id !== null && this.invoice.id !== undefined) {
            this.branches.forEach((branch, index) => {
                branch.items.forEach((item, ind) => {
                    if (this.checkEquality(item.value, this.invoice.invoiceGstDetail)) {
                        // this.selectedBranch = this.createBranchItemObject(item.value);
                        this.selectedBranchObject = this.createBranchItemObject(item.value);
                        // this.selectedBranch = this.selectedBranchObject.branchAddress[0];
                        this.selectedBranch = item.value;
                        this.groupedDropdown.value = item.value;
                        // this.selectedBranch = { "address": { "address1": "Muumbai", "address2": null, "postalCode": "456656", "state": { "createdDate": "2018-01-29T13:58:09.556Z", "createdBy": "SYSTEM", "updatedDate": "2018-01-29T13:58:09.556Z", "updatedBy": "SYSTEM", "isActive": true, "id": "5a6f287170bbb23228b5801f", "metadata": {}, "note": null, "name": "Maharashtra", "code": "MH", "key": "27", "country": { "createdDate": "2018-01-29T13:58:05.247Z", "createdBy": "SYSTEM", "updatedDate": "2018-01-29T13:58:05.247Z", "updatedBy": "SYSTEM", "isActive": true, "id": "5a6f286d70bbb23228b57f7a", "metadata": {}, "note": null, "name": "India", "code": "IN", "key": "1269750", "isoNumeric": "356", "isoAlpha3": "IND", "fipsCode": "IN" } }, "district": { "createdDate": "2018-08-09T06:52:31.969Z", "createdBy": "SYSTEM", "updatedDate": "2018-08-09T06:52:31.969Z", "updatedBy": "SYSTEM", "isActive": true, "id": "5ba9e96b0c4cd02bd859ec75", "metadata": {}, "note": null, "name": "Mumbai", "code": "MUM", "key": null, "state": { "createdDate": "2018-01-29T13:58:09.556Z", "createdBy": "SYSTEM", "updatedDate": "2018-01-29T13:58:09.556Z", "updatedBy": "SYSTEM", "isActive": true, "id": "5a6f287170bbb23228b5801f", "metadata": {}, "note": null, "name": "Maharashtra", "code": "MH", "key": "27", "country": { "createdDate": "2018-01-29T13:58:05.247Z", "createdBy": "SYSTEM", "updatedDate": "2018-01-29T13:58:05.247Z", "updatedBy": "SYSTEM", "isActive": true, "id": "5a6f286d70bbb23228b57f7a", "metadata": {}, "note": null, "name": "India", "code": "IN", "key": "1269750", "isoNumeric": "356", "isoAlpha3": "IND", "fipsCode": "IN" } }, "category": null }, "city": { "createdDate": "2018-08-09T06:57:41.849Z", "createdBy": "SYSTEM", "updatedDate": "2018-08-09T06:57:41.849Z", "updatedBy": "SYSTEM", "isActive": true, "id": "5ba9e9cf0c4cd02bd859ec79", "metadata": {}, "note": null, "name": "Mumbai", "code": "MUM", "key": null, "geoCoordinate": { "longitude": 0, "latitude": 0 }, "district": { "createdDate": "2018-08-09T06:52:31.969Z", "createdBy": "SYSTEM", "updatedDate": "2018-08-09T06:52:31.969Z", "updatedBy": "SYSTEM", "isActive": true, "id": "5ba9e96b0c4cd02bd859ec75", "metadata": {}, "note": null, "name": "Mumbai", "code": "MUM", "key": null, "state": { "createdDate": "2018-01-29T13:58:09.556Z", "createdBy": "SYSTEM", "updatedDate": "2018-01-29T13:58:09.556Z", "updatedBy": "SYSTEM", "isActive": true, "id": "5a6f287170bbb23228b5801f", "metadata": {}, "note": null, "name": "Maharashtra", "code": "MH", "key": "27", "country": { "createdDate": "2018-01-29T13:58:05.247Z", "createdBy": "SYSTEM", "updatedDate": "2018-01-29T13:58:05.247Z", "updatedBy": "SYSTEM", "isActive": true, "id": "5a6f286d70bbb23228b57f7a", "metadata": {}, "note": null, "name": "India", "code": "IN", "key": "1269750", "isoNumeric": "356", "isoAlpha3": "IND", "fipsCode": "IN" } }, "category": null }, "category": null }, "branchName": "Mumbai", "copiedAddress": false }, "gst": { "gstNo": "27DBHSMJFBHJKSH", "panNo": "DBHSMJFBHJ", "branchAddress": [{ "address1": "Muumbai", "address2": null, "postalCode": "456656", "state": { "createdDate": "2018-01-29T13:58:09.556Z", "createdBy": "SYSTEM", "updatedDate": "2018-01-29T13:58:09.556Z", "updatedBy": "SYSTEM", "isActive": true, "id": "5a6f287170bbb23228b5801f", "metadata": {}, "note": null, "name": "Maharashtra", "code": "MH", "key": "27", "country": { "createdDate": "2018-01-29T13:58:05.247Z", "createdBy": "SYSTEM", "updatedDate": "2018-01-29T13:58:05.247Z", "updatedBy": "SYSTEM", "isActive": true, "id": "5a6f286d70bbb23228b57f7a", "metadata": {}, "note": null, "name": "India", "code": "IN", "key": "1269750", "isoNumeric": "356", "isoAlpha3": "IND", "fipsCode": "IN" } }, "district": { "createdDate": "2018-08-09T06:52:31.969Z", "createdBy": "SYSTEM", "updatedDate": "2018-08-09T06:52:31.969Z", "updatedBy": "SYSTEM", "isActive": true, "id": "5ba9e96b0c4cd02bd859ec75", "metadata": {}, "note": null, "name": "Mumbai", "code": "MUM", "key": null, "state": { "createdDate": "2018-01-29T13:58:09.556Z", "createdBy": "SYSTEM", "updatedDate": "2018-01-29T13:58:09.556Z", "updatedBy": "SYSTEM", "isActive": true, "id": "5a6f287170bbb23228b5801f", "metadata": {}, "note": null, "name": "Maharashtra", "code": "MH", "key": "27", "country": { "createdDate": "2018-01-29T13:58:05.247Z", "createdBy": "SYSTEM", "updatedDate": "2018-01-29T13:58:05.247Z", "updatedBy": "SYSTEM", "isActive": true, "id": "5a6f286d70bbb23228b57f7a", "metadata": {}, "note": null, "name": "India", "code": "IN", "key": "1269750", "isoNumeric": "356", "isoAlpha3": "IND", "fipsCode": "IN" } }, "category": null }, "city": { "createdDate": "2018-08-09T06:57:41.849Z", "createdBy": "SYSTEM", "updatedDate": "2018-08-09T06:57:41.849Z", "updatedBy": "SYSTEM", "isActive": true, "id": "5ba9e9cf0c4cd02bd859ec79", "metadata": {}, "note": null, "name": "Mumbai", "code": "MUM", "key": null, "geoCoordinate": { "longitude": 0, "latitude": 0 }, "district": { "createdDate": "2018-08-09T06:52:31.969Z", "createdBy": "SYSTEM", "updatedDate": "2018-08-09T06:52:31.969Z", "updatedBy": "SYSTEM", "isActive": true, "id": "5ba9e96b0c4cd02bd859ec75", "metadata": {}, "note": null, "name": "Mumbai", "code": "MUM", "key": null, "state": { "createdDate": "2018-01-29T13:58:09.556Z", "createdBy": "SYSTEM", "updatedDate": "2018-01-29T13:58:09.556Z", "updatedBy": "SYSTEM", "isActive": true, "id": "5a6f287170bbb23228b5801f", "metadata": {}, "note": null, "name": "Maharashtra", "code": "MH", "key": "27", "country": { "createdDate": "2018-01-29T13:58:05.247Z", "createdBy": "SYSTEM", "updatedDate": "2018-01-29T13:58:05.247Z", "updatedBy": "SYSTEM", "isActive": true, "id": "5a6f286d70bbb23228b57f7a", "metadata": {}, "note": null, "name": "India", "code": "IN", "key": "1269750", "isoNumeric": "356", "isoAlpha3": "IND", "fipsCode": "IN" } }, "category": null }, "category": null }, "branchName": "Mumbai", "copiedAddress": false }], "salesType": null, "suppliableStates": null } };
                        // this.detectChanges();
                        // this.selectedBranch = this.branches[1].value;
                        // this.invoiceDetailForm.setValue({
                        //     displayName: this.campaign.displayName,
                        //     selectedCompany: this.selectedCompany,
                        //     selectedBranch: this.selectedBranch,
                        //     gst: this.gst,
                        //     state: this.state,
                        //     address: this.address,
                        //     selectedPlaceOfSupply: this.selectedPlaceOfSupply,
                        //     selectedPO: this.selectedPO
                        // });
                    }
                });
            });
        } else {
            // do nothing
            // =========================================================================================

            this.branches.forEach((branch, index) => {
                branch.items.forEach((item, ind) => {
                    if (this.checkEquality(item.value, this.invoice.invoiceGstDetail)) {
                        // this.selectedBranch = this.createBranchItemObject(item.value);
                        this.selectedBranchObject = this.createBranchItemObject(item.value);
                        // this.selectedBranch = this.selectedBranchObject.branchAddress[0];
                        this.selectedBranch = item.value;
                        this.groupedDropdown.value = item.value;
                        // this.detectChanges();
                        // this.selectedBranch = this.branches[1].value;
                        // this.invoiceDetailForm.setValue({
                        //     displayName: this.campaign.displayName,
                        //     selectedCompany: this.selectedCompany,
                        //     selectedBranch: this.selectedBranch,
                        //     gst: this.gst,
                        //     state: this.state,
                        //     address: this.address,
                        //     selectedPlaceOfSupply: this.selectedPlaceOfSupply,
                        //     selectedPO: this.selectedPO
                        // });
                    }
                });
            });

            // ===========================================================================================
        }
        // =========================== changes for auto select of branch if only one company and one branch are present =============================================

        if (this.companies.length === 1 && this.branches.length === 1) {
            if (!this.selectedBranch) {
                this.selectedBranchObject = this.createBranchItemObject(this.branches[0].items[0].value);
                this.selectedBranch = this.branches[0].items[0].value;
                this.groupedDropdown.value = this.branches[0].items[0].value;
            }
        }

        // ============================================================== end =======================================================================================
        // this.detectChanges();
        this.setGST();
    }

    checkEquality(item, gstDetail) {
        console.log("inv and sup gst det", this.invoice.invoiceGstDetail, this.invoice.supplier.supplierGstDetail);
        let result = false;
        console.log("item and gst detail", gstDetail);
        if (item.gst.gstNo === gstDetail.gstNo && item.gst.panNo === gstDetail.panNo &&
            item.address.address1 === gstDetail.branchAddress.address1 &&
            item.address.branchName === gstDetail.branchAddress.branchName &&
            item.address.postalCode === gstDetail.branchAddress.postalCode) {
            result = true;
        }
        return result;
    }

    setGST() {
        this.placeOfSupply.splice(1);
        if (this.selectedBranchObject && this.selectedBranchObject !== "" && this.selectedBranchObject.gstNo) {
            if (this.selectedBranchObject && this.selectedBranchObject.branchAddress[0] && this.selectedBranchObject.branchAddress[0].state && this.selectedBranchObject.branchAddress[0].state.name !== 'Gujarat') {
                this.placeOfSupply.push({ label: this.selectedBranchObject.branchAddress[0].state.name, value: this.selectedBranchObject.branchAddress[0].state.name });
            }
        } else {
            // do nothing
        }
        this.selectedPlaceOfSupply = this.placeOfSupply[this.placeOfSupply.length - 1].value;
        // if (this.selectedBranchObject && this.selectedBranchObject !== "") {
        this.setPlaceOfSupply();
        this.setStateAndAddress();
        // }
        // this.setPan();
        // this.detectChanges();
        this.invoice.invoiceGstDetail = new InvoiceGstDetail().setInvoiceGstDetail(this.selectedBranchObject);
        this.invoice = JSON.parse(JSON.stringify(this.invoice));
        // if (this.selectedBranchObject && this.selectedBranchObject !== "") {
        this.eEmitSelectedBranch.emit(this.selectedBranchObject);
        // }
        // this.detectChanges();
    }

    setStateAndAddress() {
        this.state = (this.selectedBranch && this.selectedBranch.address && this.selectedBranch.address.state) ? this.selectedBranch.address.state.name : (this.invoice && this.invoice.campaign && this.invoice.campaign.customer && this.invoice.campaign.customer.state && this.invoice.campaign.customer.state.name) ? this.invoice.campaign.customer.state.name : '';
        // this.address = this.selectedBranch.address.address1 ? this.selectedBranch.address.address2 ? this.selectedBranch.address.address1 + ',' + this.selectedBranch.address.address2 : this.selectedBranch.address.address1 : this.selectedBranch.address.address2 ? this.selectedBranch.address.address2 : '';
        this.address = (this.selectedBranch && this.selectedBranch.address) ? (this.selectedBranch.address.address1 ? this.selectedBranch.address.address2 ? this.selectedBranch.address.address1 + ',' + this.selectedBranch.address.address2 : this.selectedBranch.address.address1 : this.selectedBranch.address.address2 ? this.selectedBranch.address.address2 : '') : (this.invoice && this.invoice.campaign && this.invoice.campaign.customer) ? (this.invoice.campaign.customer.address1 ? this.invoice.campaign.customer.address2 ? this.invoice.campaign.customer.address1 + ',' + this.invoice.campaign.customer.address2 : this.invoice.campaign.customer.address1 : this.invoice.campaign.customer.address2 ? this.invoice.campaign.customer.address2 : '') : '';
        this.gst = (this.selectedBranch && this.selectedBranch.gst && this.selectedBranch.gst.gstNo) ? this.selectedBranch.gst.gstNo : '';
        this.pan = (this.selectedBranch && this.selectedBranch.gst) ? this.selectedBranch.gst.panNo : (this.selectedCompany && this.selectedCompany.pan) ? this.selectedCompany.pan : '';
    }

    setPan() {
        this.pan = (this.selectedBranch && this.selectedBranch.gst) ? this.selectedBranch.gst.panNo : (this.selectedCompany && this.selectedCompany.pan) ? this.selectedCompany.pan : '';
    }

    setPOList() {
        this.purchaseOrders = [];
        this.campaign.purchaseOrders.forEach((PO) => {
            // let unique = true;
            // this.purchaseOrders.forEach((ipo) => { // finding unique
            //     if (PO.name === ipo.label) {
            //         unique = false;
            //     }
            // });
            // if (unique) {
            this.purchaseOrders.push({ label: PO.name, value: PO });
            // }
        });

        if (this.purchaseOrders.length > 0) {
            if (this.invoice.purchaseOrders.length > 0) {
                this.setSelectedPO();
            }
            // ================================ changes to auto select the po if only one po is present ============================================================

            else {
                // if (this.selectedPO.length === 0 && this.purchaseOrders.length === 1) {
                //     this.selectedPO.push(this.purchaseOrders[0].value);
                // this.selectedPO = JSON.parse(JSON.stringify(this.selectedPO));
                // this.emitPO();
                // }
                this.selectedPO = JSON.parse(JSON.stringify(this.selectedPO));
                this.emitPO();
            }

            // ================================================== end ===============================================================================================
        }

    }

    setSelectedPO() {

        const poToPush: any[] = [];
        this.purchaseOrders.forEach((po) => {
            this.invoice.purchaseOrders.forEach((ipo) => {
                // if (po.value === ipo) {
                //     this.selectedPO.push(po);
                //     console.log(this.selectedPO);
                // }
                if (po.value.name === ipo.name && po.value.folder === ipo.folder && po.value.url === ipo.url) {
                    // this.selectedPO = po;
                    poToPush.push(po.value);
                }
            });
        });
        this.selectedPO = poToPush;
        this.selectedPO = JSON.parse(JSON.stringify(this.selectedPO));
        this.emitPO();
    }

    setPlaceOfSupply() {
        // if (this.selectedPlaceOfSupply) {
        //     this.invoice.placeOfSupply = this.selectedPlaceOfSupply;
        // } else {
        // this.selectedPlaceOfSupply = this.placeOfSupply[0].value;
        if (this.selectedPlaceOfSupply) {
            this.invoice.placeOfSupply = this.selectedPlaceOfSupply;
        } else {
            this.selectedPlaceOfSupply = this.placeOfSupply[this.placeOfSupply.length - 1].value;
        }
        // }
        this.eEmitSelectedPlaceOfSupply.emit(this.selectedPlaceOfSupply);
        // this.invoiceDetailForm.setValue({
        //     displayName: this.campaign.displayName,
        //     selectedCompany: this.selectedCompany,
        //     selectedBranch: this.selectedBranch,
        //     gst: this.gst,
        //     state: this.state,
        //     address: this.address,
        //     selectedPlaceOfSupply: this.selectedPlaceOfSupply,
        //     selectedPO: this.selectedPO,
        // });
    }

    uploadPO() {
        this.setImageFolderConfig();
        this.displayUploadPODialog = true;
    }

    setImageFolderConfig() {
        this.imageFolderConfig.campaignId = this.campaign.id;
        this.imageFolderConfig.moduleSubType = "purchaseOrder";
        this.imageFolderConfig.moduleName = "campaigns";
    }

    hideUploadPODialog() {
        this.displayUploadPODialog = false;
    }

    setInvoiceNote(event) {
        this.invoiceNote = event.target.value;
        this.eEmitInvoiceNote.emit(this.invoiceNote);
    }

    setInternalNotes(event) {
        this.internalNotes = event.target.value;
        this.eEmitInternalNote.emit(this.internalNotes);
    }

    setInvoiceRefId(event) {
        this.refInvoiceId = event.target.value;
        this.eEmitInvoiceRefId.emit(this.refInvoiceId);
    }

    setPrintConfigurations(configuration) {

        switch (configuration) {
            case "000": {
                this.isDuplicate = true;
                this.isWithoutDetail = true;
                this.isWithoutLetterHead = true;
                break;
            }
            case "001": {
                this.isDuplicate = true;
                this.isWithoutDetail = true;
                this.isWithoutLetterHead = false;
                break;
            }
            case "010": {
                this.isDuplicate = true;
                this.isWithoutDetail = false;
                this.isWithoutLetterHead = true;
                break;
            }
            case "011": {
                this.isDuplicate = true;
                this.isWithoutDetail = false;
                this.isWithoutLetterHead = false;
                break;
            }
            case "100": {
                this.isDuplicate = false;
                this.isWithoutDetail = true;
                this.isWithoutLetterHead = true;
                break;
            }
            case "101": {
                this.isDuplicate = false;
                this.isWithoutDetail = true;
                this.isWithoutLetterHead = false;
                break;
            }
            case "110": {
                this.isDuplicate = false;
                this.isWithoutDetail = false;
                this.isWithoutLetterHead = true;
                break;
            }
            case "111": {
                this.isDuplicate = false;
                this.isWithoutDetail = false;
                this.isWithoutLetterHead = false;
                break;
            }
        }

        this.changedPrintArray = [this.isDuplicate, this.isWithoutDetail, this.isWithoutLetterHead];

    }

    setPO(event) {
        if (event && event.length) {
            this.poToSet = [];
            this.loading = true;
            const campaignQueryParams: CampaignQueryParams = new CampaignQueryParams();
            campaignQueryParams.campaignId = this.campaign.id;
            campaignQueryParams.purchseOrders = event;
            this.poToSet = campaignQueryParams.purchseOrders;
            this.billingActionDispatcher.uploadInvoicePO(campaignQueryParams);
        }
        // pipe(takeUntil(this.poUnsub)).
        this.subscription.push(this.billingActionDispatcher.isPOUploaded.pipe(takeUntil(this.poUnsub)).subscribe((isPOUploaded) => {
            if (isPOUploaded) {
                this.billingActionDispatcher.resetIsPOUploaded();
                this.loading = false;
                this.poUnsub.next(true);
                // this.ngOnInit();
                // this.poToSet.forEach((e) => {
                //     if (this.selectedPO.filter(po => po.name !== e.name && po.folder !== e.folder && po.url !== e.url)) {
                //         this.invoice.purchaseOrders.push(e);
                //     }
                // });
                this.invoice.purchaseOrders = [...this.invoice.purchaseOrders, ...this.poToSet];
                // console.log("pos", this.invoice.purchaseOrders);
                this.getCampaign();
                // this.billingActionDispatcher.resetIsPOUploaded();
                // this.setSelectedPO();
            }
        }));
        this.subscription.push(this.billingActionDispatcher.isError.subscribe((isError) => {
            if (isError) {
                this.loading = false;
                this.billingActionDispatcher.resetError();
            }
        }));
    }

    /**
     * on value change of grouped checkbox
     *
     * @param {*} event
     * @memberof AddInvoiceDetailsComponent
     */
    onGroupedValueChange(event) {
        this.grouped = event;
        this.eEmitIsGrouped.emit(this.grouped);
    }

    ngAfterViewInit() { }

    emitPO() {
        // console.log(this.purchaseOrders);
        // console.log(this.selectedPO);
        this.eEmitSelectedPO.emit(this.selectedPO);
    }

    resetDetails() {
        this.selectedBranch = null;
        this.invoice.invoiceGstDetail = new InvoiceGstDetail().setInvoiceGstDetail(this.selectedBranch);
        this.eEmitSelectedCompany.emit(this.selectedCompany);
        // this.eEmitSelectedBranch.emit(this.selectedBranch);
    }

    checkFormValidity() {
        // if (this.invoiceDetailForm.form.valid) {
        if (this.invoiceDetailForm.valid && ((this.branchDropdown && this.selectedBranch) || (!this.branchDropdown)) && ((this.supplierBranchDropdown && this.selectedSupplierBranch) || (!this.supplierBranchDropdown))) {
            return true;
        } else {
            return false;
        }
    }

    viewPO(po) {
        this.firebaseService.downloadImage(po.value.name, po.value.folder).then((response) => {
            window.open(response);
        });
    }

    getChangedType() {
        if (!this.migratedInvoice) {
            return ActivityLogModuleEnum.INVOICE;
        } else {
            return ActivityLogModuleEnum.MIGRATED_INVOICE;
        }
    }

    // savePrintingInstructions(isDuplicate, isWithoutDetail, isWithoutLetterHead) {
    //     if (this._invoice && this.isPrintOptionChanged) {
    //         isDuplicate = this.changedPrintArray[0];
    //         isWithoutDetail = this.changedPrintArray[1];
    //         isWithoutLetterHead = this.changedPrintArray[2];
    //     }
    //     var printConfiguration;
    //     if (isDuplicate && isWithoutDetail && isWithoutLetterHead) {
    //         printConfiguration = "000";
    //     } else if (isDuplicate && isWithoutDetail && !isWithoutLetterHead) {
    //         printConfiguration = "001"
    //     } else if (isDuplicate && !isWithoutDetail && isWithoutLetterHead) {
    //         printConfiguration = "010";
    //     } else if (isDuplicate && !isWithoutDetail && !isWithoutLetterHead) {
    //         printConfiguration = "011";
    //     } else if (!isDuplicate && isWithoutDetail && isWithoutLetterHead) {
    //         printConfiguration = "100";
    //     } else if (!isDuplicate && isWithoutDetail && !isWithoutLetterHead) {
    //         printConfiguration = "101";
    //     } else if (!isDuplicate && !isWithoutDetail && isWithoutLetterHead) {
    //         printConfiguration = "110";
    //     } else if (!isDuplicate && !isWithoutDetail && !isWithoutLetterHead) {
    //         printConfiguration = "111";
    //     } else {
    //         //
    //     }

    //     this.invoice.printConfiguration = printConfiguration;
    // this.eEmitPrintConfiguration.emit(printConfiguration);
    // this.notificationService.success('Configuration Saved Successfully', 'Configuration Saved');
    // this.printOverlay = false;
    // this.printMenu.hide();

    // }

    onPrintTypeChange(event) {
        this.original = event;
        this.eEmitChangedPrintType.emit(this.original);
    }

    onPrintLetterHeadChange(event) {
        this.withLetterHead = event;
        this.eEmitChangedPrintLetterHead.emit(this.withLetterHead);
    }

    savePrintingInstructions(printConfig: PrintConfig) {
        this.invoice.printConfiguration = printConfig;
        this.eEmitPrintConfiguration.emit(printConfig);
        this.printOverlay = false;
        this.printMenu.hide();
        if (this.invoice && this.invoice.id) {
            this.commonService.saveBillingPrintConfig(this.invoice.printConfiguration, this.selectedInvoiceFormat, this.invoice.id, this.migratedInvoice ? SIBConstants.MIGRATED_INVOICE_PARAM : SIBConstants.INVOICE_PARAM)
                .subscribe(
                    (response) => {
                        if (response) {
                            this.notificationService.success('Configuration Saved Successfully', 'Configuration Saved');
                        }
                    },
                    (error) => {
                        this.notificationService.error(error.error ? error.error.message ? error.error.message : 'Some technical issue' : error.message, 'Error!!');
                    }
                );
        } else {
            this.notificationService.success('Configuration Saved Successfully', 'Configuration Saved');
        }
    }

    previewPrintItems(printConfig: PrintConfig) {
        this.eEmitPreviewPrintItems.emit(printConfig);
    }

    showPrintOverlay($event) {
        // if (this.invoice.printConfiguration) {
        //     this.setPrintConfigurations(this.invoice.printConfiguration);
        // }
        this.printConfig = this.invoice.printConfiguration;
        this.printOverlay = true;
        this.printMenu.show($event);
    }
    handleLetterHeadChange(event) {
        this.isPrintOptionChanged = true;
        this.changedPrintArray[2] = event.checked;
        this.changedPrintArray = _.cloneDeep(this.changedPrintArray);
        // this.isWithoutLetterHead = !event.checked;
    }

    handleDetailChange(event) {
        this.isPrintOptionChanged = true;
        // this.isWithoutDetail = !event.checked;
        this.changedPrintArray[1] = event.checked;
        this.changedPrintArray = _.cloneDeep(this.changedPrintArray);
    }

    handleDuplicateChange(event) {
        this.isPrintOptionChanged = true;
        // this.isDuplicate = !event.checked;
        this.changedPrintArray[0] = event.checked;
        this.changedPrintArray = _.cloneDeep(this.changedPrintArray);
    }

    hidePrintOverlay($event) {
        this.printOverlay = false;
        this.printMenu.hide();
    }

    /**
     * @description show dialog for adding invoice Id
     * @author Divya Sachan
     * @date 2019-12-16
     * @memberof AddInvoiceDetailsComponent
     */
    showInvoiceIdDialog() {
        this.displayInvoiceIdDialog = !this.migratedInvoice ? true : false;
        if (this.displayInvoiceIdDialog) {
            this.invoiceId = this.invoice && this.invoice.invoiceId === this.invoiceId ? this.invoiceId : this.invoiceId;
        }
    }

    /**
     * @description hide invoice Id dialog
     * @author Divya Sachan
     * @date 2019-12-16
     * @memberof AddInvoiceDetailsComponent
     */
    hideInvoiceIdDialog() {
        this.eEmitInvoiceId.emit(this.invoiceId);
        this.displayInvoiceIdDialog = false;
    }

    /**
     * @description validate entered Invoice Id
     * @author Divya Sachan
     * @date 2019-12-16
     * @param {*} invoiceId
     * @memberof AddInvoiceDetailsComponent
     */
    validateInvoiceId(invoiceId) {
        this.isLoading = true;
        this.invoiceId = invoiceId;
        // if (this.invoice && this.invoice.invoiceId && this.invoice.invoiceId === invoiceId) { // if entered invoice id is equal invoice's invoice id
        if (this.invoice && this.initialInvoiceId && this.initialInvoiceId === invoiceId) { // if entered invoice id is equal invoice's invoice id
            this.hideInvoiceIdDialog();
            this.isLoading = false;
            // this.eEmitInvoiceId.emit(this.invoiceId);
            // } else if (!this.invoice.invoiceId || (this.invoice && this.invoice.invoiceId && this.invoice.invoiceId !== invoiceId)) { // if entered invoice id does not or is not equal to invoice's invoice id
        } else if (!this.initialInvoiceId || (this.invoice && this.initialInvoiceId && this.initialInvoiceId !== invoiceId)) { // if entered invoice id does not or is not equal to invoice's invoice id
            this.invoiceService.get({ invoiceId: invoiceId }, AppUrls.VALIDATE_INV_ID).subscribe(response => {
                if (response['data']) {
                    this.hideInvoiceIdDialog();
                    !this.invoice.invoiceId ? this.notificationService.info(invoiceId + ' added Successfully', 'Add Invoice Id') : (!this.invEditPending ? this.notificationService.info(invoiceId + ' changed Successfully', 'Change Invoice Id') : this.notificationService.info(invoiceId + ' edited Successfully', 'Edit Invoice Id'));

                    this.isLoading = false;
                    // this.eEmitInvoiceId.emit(this.invoiceId);
                }
            }, (error) => { // error
                const errorObject = ErrorUtil.getErrorObject(error);
                if (errorObject.code === 417 || errorObject.code === 412) {
                    this.notificationService.info(errorObject.message ? errorObject.message : NotificationsMessages.DUPLICATE_INV_ID, NotificationsMessages.INFORMATION);
                } else {
                    this.notificationService.error(errorObject.message ? errorObject.message : NotificationsMessages.TECHNICAL_ISSUE, NotificationsMessages.ERROR)
                }
                this.isLoading = false;
                this.eEmitInvoiceId.emit(undefined);
                return error;
            });
        }

    }

    /**
     * @description get inv id creation strategy from billing system properties
     * @author Divya Sachan
     * @date 2019-12-16
     * @memberof AddInvoiceDetailsComponent
     */
    getBillingConfiguration() {
        this.billingConfigurationService.getBillingConfiguration();
        this.subscription.push(this.billingConfigurationService.invIdCreationStrategy.subscribe((invIdCreationStrategy) => {
            this.invIdCreationStrategy = invIdCreationStrategy;
            if (invIdCreationStrategy === 'MANUAL') {
                if (this.invoice && this.invoice.status) {
                    this.invoice.status === 'EDIT_PENDING' ? this.invEditPending = true : this.invEditPending = false;
                    if (this.invoice.invoiceId) {
                        this.eEmitInvoiceId.emit(this.invoice.invoiceId);
                    }
                } else {
                    this.displayInvoiceIdDialog = true;
                }
            }
            this.eEmitInvoiceIdCreationStrategy.emit(invIdCreationStrategy);
        }));
    }

    detectChanges() {
        if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
        }
    }

    ngOnDestroy() {
        this.subscription.forEach((s) => {
            s.unsubscribe();
        });
        this.poUnsub.unsubscribe();
    }

}
